// extracted by mini-css-extract-plugin
module.exports =  {"root":"es_ypI66JI7avKucEhp0","instagramIndicator":"qJbTjnaWCXghsIKz3_5o"};